(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/overview.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/overview.js');
'use strict';

const Overview = () => React.createElement("div", null, React.createElement(svs.grassroots_partner.Logout, null), React.createElement(svs.grassroots_partner.PaymentHistory, null));
svs.grassroots_partner.Overview = Overview;

 })(window);